import axios, {AxiosResponse} from 'axios';

export async function UnwrapResponse<T>(input: Promise<AxiosResponse<T>>): Promise<T> {
    return (await input).data;
}
